export default __webpack_public_path__ + "ff99bdf791b276340fb25c3b92535b0a.png";